import { Check } from "lucide-react";

const steps = [
  { number: 1, label: "Introduction" },
  { number: 2, label: "Diffusion" },
  { number: 3, label: "Configuration" },
  { number: 4, label: "Coordonnées" },
  { number: 5, label: "Récapitulatif" },
  { number: 6, label: "Signature" },
  { number: 7, label: "Paiement" },
  { number: 8, label: "Confirmation" }
];

const ProgressBar = ({ currentStep }) => {
  return (
    <div data-testid="progress-bar" className="w-full py-6 bg-[#fff8ed]">
      <div className="max-w-6xl mx-auto px-4">
        {/* Desktop Progress */}
        <div className="hidden lg:flex items-center justify-between">
          {steps.map((step, index) => (
            <div key={step.number} className="flex items-center">
              {/* Step Circle */}
              <div className="flex flex-col items-center">
                <div
                  className={`w-9 h-9 flex items-center justify-center border-2 transition-all duration-300 ${
                    currentStep > step.number
                      ? "bg-[#0A0A0A] border-[#0A0A0A] text-white"
                      : currentStep === step.number
                      ? "bg-[#B89F7C] border-[#B89F7C] text-white"
                      : "bg-transparent border-[#E5E5E5] text-[#525252]"
                  }`}
                >
                  {currentStep > step.number ? (
                    <Check size={16} strokeWidth={2} />
                  ) : (
                    <span className="font-body text-xs font-medium">{step.number}</span>
                  )}
                </div>
                <span
                  className={`mt-2 font-body text-[10px] tracking-wide text-center whitespace-nowrap ${
                    currentStep >= step.number ? "text-[#0A0A0A]" : "text-[#525252]"
                  }`}
                >
                  {step.label}
                </span>
              </div>
              
              {/* Connector Line */}
              {index < steps.length - 1 && (
                <div
                  className={`w-8 xl:w-14 h-[2px] mx-1 xl:mx-2 transition-all duration-300 ${
                    currentStep > step.number ? "bg-[#0A0A0A]" : "bg-[#E5E5E5]"
                  }`}
                />
              )}
            </div>
          ))}
        </div>

        {/* Tablet Progress */}
        <div className="hidden md:flex lg:hidden items-center justify-between">
          {steps.map((step, index) => (
            <div key={step.number} className="flex items-center">
              <div className="flex flex-col items-center">
                <div
                  className={`w-8 h-8 flex items-center justify-center border-2 transition-all duration-300 ${
                    currentStep > step.number
                      ? "bg-[#0A0A0A] border-[#0A0A0A] text-white"
                      : currentStep === step.number
                      ? "bg-[#B89F7C] border-[#B89F7C] text-white"
                      : "bg-transparent border-[#E5E5E5] text-[#525252]"
                  }`}
                >
                  {currentStep > step.number ? (
                    <Check size={14} strokeWidth={2} />
                  ) : (
                    <span className="font-body text-xs font-medium">{step.number}</span>
                  )}
                </div>
              </div>
              {index < steps.length - 1 && (
                <div
                  className={`w-6 h-[2px] mx-1 transition-all duration-300 ${
                    currentStep > step.number ? "bg-[#0A0A0A]" : "bg-[#E5E5E5]"
                  }`}
                />
              )}
            </div>
          ))}
        </div>
        <div className="hidden md:block lg:hidden text-center mt-2">
          <span className="font-body text-xs text-[#0A0A0A]">
            {steps[currentStep - 1]?.label}
          </span>
        </div>

        {/* Mobile Progress */}
        <div className="md:hidden">
          <div className="flex items-center justify-between mb-2">
            <span className="font-body text-sm text-[#525252]">
              Étape {currentStep} sur {steps.length}
            </span>
            <span className="font-body text-sm font-medium text-[#0A0A0A]">
              {steps[currentStep - 1]?.label}
            </span>
          </div>
          <div className="w-full h-2 bg-[#E5E5E5] rounded-full overflow-hidden">
            <div
              className="h-full bg-[#B89F7C] transition-all duration-500"
              style={{ width: `${(currentStep / steps.length) * 100}%` }}
            />
          </div>
        </div>
      </div>
    </div>
  );
};

export default ProgressBar;
